module.exports = __webpack_public_path__ + "img/Report-card.4da23eff.png";